import { DashboardEvent } from "../types/DashboardEvent";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import UsbIcon from '@mui/icons-material/Usb';
import UsbOffIcon from '@mui/icons-material/UsbOff';


export const iotGatewayEvents: DashboardEvent[ ] = [

    {
        
        displayedText: 'Connected',
        event: 'CONNECTED',
        icon: <UsbIcon sx={{color:'green'}} />
    },

    {
        
        displayedText: 'Disconnected',
        event: 'DISCONNECTED',
        icon: <UsbOffIcon sx={{color:'red'}} />
    },

    {
        
        displayedText: 'Missing',
        event: 'MISSING',
        icon: <HelpOutlineIcon sx={{color:'red'}} />
    }

];